<template>
    <div>
        <Layout>
            <Content class="content">
                <div class="box">
                    <span class="item">
                        <NextBar v-if="renderbar" :style="{display:showBar?'block':'none'}" :isHidden=true ref="casesearch" :isShowLayer=false :isShowSearchBox=false :isTaxCase=false @next-search="nextSearch"></NextBar>
                    </span>
                    <span class="item">
                        <RTable class="jd-table-overflow" ref="caseTable" @download="downloadtablefile" @onPageChange="pageChange" />
                    </span>
                </div>
            </Content>
            <Spin fix v-if="spinShow3">
                <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                <div v-if="loadSucess">数据加载中...</div>
                <div v-else>加载失败</div>
            </Spin>
        </Layout>
    </div>
</template>
<script>
import caseHeader from '../../assets/json/caseTableData.json'
import nextSearchBar from '../common/common_engine/nextSearchBar3.vue'
import rtable from '../common/common_engine/resulttable.vue'
import eventBus from "../common/event_bus.js"
import More from "../../api/common/more.js"
import store from '../../store/'
import ConstJson from "../../api/common/constjson.js"
let constJ = new ConstJson()
let MoreFun = new More()
export default {
    inject: ["getSliders"],
    data() {
        return {
            rid: +new Date(),
            showBar: true,
            psize: 10,
            index: 1,
            searchtxt: '',
            spinShow3: true,
            loadSucess: true,
            sliders: this.getSliders(),
            renderbar: false,
            nextValue: null,

        }
    },
    components: {
        'NextBar': nextSearchBar,
        'RTable': rtable,
    },
    created() {
        //store.state.user.initData.currentVersion = '2'
        //this.$refs.myAsideMenu.init()
        console.log('tax_case_search create==>')
        this.$nextTick(() => {
            if (store.state.user.initData.taxCaseCategory.length === 0) {
                console.log('拉取taxCaseCategory数据')
                this.getCaseCategory()
            } else {
                console.log('已存在taxCaseCategory数据')
                //console.log(store.state.user.initData.court)
                this.spinShow3 = false
                //renderbar
                this.renderbar = true
            }

        })
        // this.spinShow3 = false
        // this.renderbar=true
        //this.test()
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        showMessage(msg) {
            //console.log(msg)
            if (msg === undefined || msg === "") {
                this.$Message.error("涉税报表文件下载出错...")
            } else {
                this.$Message.error(msg)
            }

        },
        //普通下载
        downloadfile(row) {
            //检查接口权限
            let code = this.$Tools.getPermission().CODE_FUNC_ONEDOWNLOAD
            let name = "普通下载"
            let po = {
                funccode: code,
                funcname: name,
            }
            this.checkUserPermission(po, 2, row)
        },
        downloadtablefile(row) {
            this.downloadfile(row)
        },
        //检查接口访问权限，验证成功则访问，验证失败则提示
        //fType,=1上传云端,=2普通下载,=3云擎下载
        checkUserPermission(po, fType, row) {
            constJ.reqCheckUserPromission(po).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        if (!res.result.protect) {
                            if (fType === 2) {
                                var strdocid = row.strdocid
                                constJ.reqDownLoadOneFile(strdocid, undefined, this.showMessage)
                            }
                        } else {
                            if (res.result.warninglevel === 1) {
                                //登录
                                eventBus.$emit("user-login", "true", "0") //临时登录
                                return
                            } else if (res.result.warninglevel === 2) {
                                //去商城账号等级
                                eventBus.$emit('user-nopermission-board', res.result.warningtext, 1)
                                return
                            } else if (res.result.warninglevel === 3) {
                                //去商城升级vip
                                eventBus.$emit('user-nopermission-board', res.result.warningtext, 2)
                                return
                            } else {
                                console.log('待处理的警告等级===>' + res.result.warninglevel)
                                return
                            }
                        }

                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {
                // this.$Message.error(err.rtndesc);
                // return
            })
        },
        pageChange(index, name) {
            this.index = index
            console.log(this.index,this.nextValue)
            if (this.nextValue) {
                this.test(this.nextValue)
            } else {
                this.text()
            }
            //console.log(index,name)
        },
        nextSearch(value) {
            console.log(value)
            this.nextValue = value
            this.index=1
            this.test(value)
        },
        test(nxtValue) {
            var item = {}
            item.text =
                item.stime = nxtValue ? nxtValue.time[0] : ''
            item.etime = nxtValue ? nxtValue.time[1] : ''
            item.potence = ""
            item.tagid = ""
            item.text2 = nxtValue ? nxtValue.text : ''
            item.ps = { "p": '', "c": '' }
            item.tagpc = []
            item.fs = true
            item.ft = false
            item.id = nxtValue ? (nxtValue.caseid !== '000000' ? nxtValue.caseid : '') : ''
            item.court = '' //nxtValue?nxtValue.court:''
            item.courttype = 0 //nxtValue?nxtValue.courttype:0
            item.scencs = 'download' ////场景(policy:政策,answer:解答,paperword:文书,taxnews:税务案例)
            console.log(item)

            constJ.reqGetGeneralFiles(this.psize, this.index, item, true).then(res => {
                console.log(res)
                if (res.rltcode === 1) {
                    if (res.rtncode === 1) {
                        var obj = null
                        if (res.tbls.length > 0) {
                            obj = {
                                header: caseHeader.taxform.header,
                                tabrows: res.tbls[0].items,
                                total: res.tbls[0].total,
                                tabname: "general",
                                tags: res.tbls[0].classifytag,
                                level: res.tbls[0].divisiontag,
                                warninglevel: res.tbls[0].warninglevel,
                                warningtext: res.tbls[0].warningtext,
                                protect: res.tbls[0].protect,
                                isws: false,
                                isjd: false,
                                iscase: false,
                                istable: true,
                                tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                                index: this.index,
                                showColumns: MoreFun.getColumns().table,
                            }
                        } else {
                            //默认
                            obj = {
                                header: testData2.header,
                                tabrows: null,
                                total: 0,
                                tabname: "general",
                                tags: res.tbls[0].classifytag,
                                level: null,
                                warninglevel: res.tbls[0].warninglevel,
                                warningtext: res.tbls[0].warningtext,
                                protect: res.tbls[0].protect,
                                tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                                index: currentIndex,
                                showColumns: [],
                            }
                        }
                        this.$refs.caseTable.show(obj)
                    } else {
                        this.$Message.error(res.rtncode)
                        console.log(res.rtncode)
                        return
                    }
                } else {
                    this.$Message.error(res.rltcode)
                    console.log(res.rltcode)
                    return
                }
            })
        },

        getCaseCategory() {
            constJ.getTaxCaseCategory().then(res => {
                console.log(res)
                let list = []
                if (res.rltcode === 1) {
                    if (res.rtncode === 1) {
                        list.push({ value: '000000', label: '全部分类' })
                        res.datas.forEach(item => {
                            let li = {
                                value: item.code,
                                label: item.text
                            }
                            list.push(li)
                        })
                        store.commit("setTaxCaseCategory", list)
                        this.spinShow3 = false
                        //renderbar
                        this.renderbar = true
                    }
                }
            })
        },
    },
    //监控多屏状态下隐藏其他字段显示，单屏还原
    watch: {
        sliders: function(v) {
            console.log('tax table sliders changed--->')
            console.log(v)
            this.$refs.caseTable.onSlidersChanged(MoreFun.getColumns().table)
        }
    }

}
</script>
<style lang="less" scoped>
.box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .item {
        margin-top: 10px;
    }

}

.content {
    padding: 0 0 0 10px;
    // Height: 749px;
    background: #fff;
    Height: 78.8vh;
}

.jd-table-overflow {
    height: 69vh;
    overflow-y: auto;
}
</style>